import React from "react";
import rightimg from "./img/IMG20250918193027.9817a578da28aa4ccabe.webp";
import "./style.css";

function Header({ scrollToComponent }) {
  return (
    <section className="w-full rounded-3xl mt-10">
      <div className="max-w-7xl mx-auto max-lg:flex-col flex px-4 gap-4">
        {/* Левая часть — изображение */}
        <div className="lg:w-1/2 max-[440px]:-mt-6">
          <img
            src={rightimg}
            alt="Ajar Mebel"
            loading="lazy"
            decoding="async"
            width="400"
            height="300"
            className="max-lg:h-[350px] w-full h-full rounded-3xl object-cover"
          />
        </div>

        {/* Правая часть — контент */}
        <div className="flex items-center px-4 lg:px-16 lg:pt-32 pt-6 pb-6 rounded-3xl bg-[#FAF9F6]">
          <div className="lg:max-w-lg">
            <h1 className="text-6xl lg:text-5xl max-sm:text-4xl font-bold text-black leading-tight">
              Стол жана стулдар <br />
              заказ боюнча Бишкекте
            </h1>

            <p className="mt-6 text-gray-600 text-base lg:text-lg leading-relaxed">
              Түз өндүрүүчү • 15 жылдык тажрыйба <br />
              Кенен жана ыңгайлуу стол-отургучтар — коноктор ыраазы, сиздин
              үйүңүз сыймыктуу.
              <br />
              <br />
              <strong>Биз сунуштайбыз:</strong>
              <br />
              • Өлчөмү, формасы жана дизайны — сиз каалагандай <br />
              • Сапаттуу материалдар: стол — Түркиялык МДФ, стулдар — 100%
              жаңгак жана ясен жыгачы <br />
              • Кепилдик — 12 ай
              <br />
              <br />
              <span className="text-black font-semibold">
                Заказды бүгүн берсеңиз — жеңилдик алыңыз!
              </span>
            </p>

            <button
              onClick={() =>
                window.open("https://wa.me/996707178620", "_blank")
              }
              className="group relative overflow-hidden flex items-center justify-between
             bg-[#A1C349] hover:bg-[#beda76] transition
             text-white text-md font-medium
             px-8 py-4 rounded-full w-[290px] mt-8"
            >
              <span className="absolute left-1 flex items-center justify-center w-12 h-12 bg-white text-black rounded-full transition-all duration-500 group-hover:left-[calc(100%-3.3rem)]">
                <ion-icon name="arrow-forward-outline"></ion-icon>
              </span>
              {/* Text */}
              <span
                className="absolute right-5 flex gap-[1px]
               transition-all duration-300
               group-hover:opacity-0 group-hover:-translate-x-4"
              >
                {"Бизге байланышыңыз".split("").map((char, i) => (
                  <span key={i}>{char === " " ? "\u00A0" : char}</span>
                ))}
              </span>

              {/* Animated text (right side) */}
              <span
                className="flex gap-[1px] opacity-0
               group-hover:opacity-100
               group-hover:translate-x-0
               translate-x-4 transition-all duration-300"
              >
                {"Бизге байланышыңыз".split("").map((char, i) => (
                  <span
                    key={i}
                    style={{ transitionDelay: `${i * 40}ms` }}
                    className="inline-block transition-all duration-300
                   opacity-0 translate-y-2
                   group-hover:opacity-100 group-hover:translate-y-0"
                  >
                    {char === " " ? "\u00A0" : char}
                  </span>
                ))}
              </span>

              {/* Arrow */}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Header;
